import { ChangeEvent, FC } from 'react';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import {
  HolidayAndWayOfWorkingRequestCode,
  RequirementsRequestCode,
} from '@doda/api-client/aspida/@types';
import {
  PickUpConditionListType,
  PickUpConditionType,
} from 'types/pickUpConditions';
import styles from './index.module.scss';
import { SearchCheckboxItem } from '../../SearchCheckboxList';

/**
 * Props
 * @param list 表示用配列
 * @param updateIsCheckedIsNewArrival 新着のチェックボックス押下処理
 * @param updateIsCheckedIsNearDeadline 締め切り間近のチェックボックス押下処理
 * @param updateIsCheckedHolidayAndWayOfWorkingList 休日・働き方のチェックボックス押下処理
 * @param updateIsCheckedRequirementList 募集・採用情報のチェックボックス押下処理
 * @param updateJobCount 求人件数更新処理
 * @param onChangeIsShowOverlay オーバーレイ表示処理
 */
interface Props {
  list: PickUpConditionListType[];
  updateIsCheckedIsNewArrival: (event: ChangeEvent<HTMLInputElement>) => void;
  updateIsCheckedIsNearDeadline: (event: ChangeEvent<HTMLInputElement>) => void;
  updateIsCheckedHolidayAndWayOfWorkingList: (
    event: ChangeEvent<HTMLInputElement>
  ) => HolidayAndWayOfWorkingRequestCode[];
  updateIsCheckedRequirementList: (
    event: ChangeEvent<HTMLInputElement>
  ) => RequirementsRequestCode[];
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
  onChangeIsShowOverlay: () => void;
}

/**
 * 検索サイドバー・こだわり条件ピックアップ
 */
export const SearchPickUpCondition: FC<Props> = ({
  list,
  updateIsCheckedIsNewArrival,
  updateIsCheckedIsNearDeadline,
  updateIsCheckedHolidayAndWayOfWorkingList,
  updateIsCheckedRequirementList,
  updateJobCount,
  onChangeIsShowOverlay,
}) => {
  const onChangeCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    pickUpType: PickUpConditionType
  ) => {
    switch (pickUpType) {
      case 'newArrival':
        updateIsCheckedIsNewArrival(event);
        updateJobCount({
          isNewArrival: event.target.checked,
        });
        break;
      case 'nearDeadline':
        updateIsCheckedIsNearDeadline(event);
        updateJobCount({
          isNearDeadline: event.target.checked,
        });
        break;
      case 'holidayAndWayOfWorking': {
        const checkedList = updateIsCheckedHolidayAndWayOfWorkingList(event);
        updateJobCount({
          holidayAndWayOfWorking: checkedList,
        });
        break;
      }
      case 'requirement': {
        const checkedList = updateIsCheckedRequirementList(event);
        updateJobCount({
          requirements: checkedList,
        });
        break;
      }
      default:
        break;
    }
  };

  return (
    <ul className={styles.searchCheckboxListWrapper}>
      {list.map((item) => (
        <li key={item.id}>
          <SearchCheckboxItem
            title={item.name}
            value={item.value}
            isChecked={item.isChecked}
            count={item.jobCount}
            onChange={(event) => {
              onChangeCheckbox(event, item.type);
              onChangeIsShowOverlay();
            }}
          />
        </li>
      ))}
    </ul>
  );
};
